/**
 * Labstep
 *
 * @module grid/SmartTableProtocolCondition/components/ToolPanel/MetadataMolecule
 * @desc Select a metadata molecule field to add as a column
 */

import { ActionComponent } from 'labstep-web/core/Action/Component';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { useToolPanelContext } from 'labstep-web/grid/Index/components/ToolPanel/context';
import { EntityDataGridToolPanelListItem } from 'labstep-web/grid/Report/components/ToolPanel/ListItem';
import { getMetadataMoleculeColDefs } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs';
import type { SmartTableColDef } from 'labstep-web/grid/SmartTableProtocolCondition/coldefs/types';
import { ToolPanelState } from 'labstep-web/grid/SmartTableProtocolCondition/components/ToolPanel';
import type React from 'react';
import type { EntityDataGridToolPanelMetadataMoleculeProps } from './types';

export const EntityDataGridToolPanelMetadataMolecule: React.FC<
  EntityDataGridToolPanelMetadataMoleculeProps
> = ({
  colIds,
  gridSmartTableProtocolConditionService,
  metadata,
  protocolValue,
  experimentOrProtocol,
}) => {
  const toolPanelContext = useToolPanelContext();
  return (
    <div>
      <Flex vAlignContent="center" spacing="gap" shrink={0}>
        <ActionComponent
          type="icon"
          icon="arrow left"
          text="Go Back"
          onClick={() =>
            toolPanelContext?.setToolPanelState(
              ToolPanelState.default,
            )
          }
        />
        <Header size="tiny" noMargin>
          Add Structure Column
        </Header>
      </Flex>
      <small>
        You must select the field that you wish to add as a column
      </small>
      {getMetadataMoleculeColDefs(
        experimentOrProtocol,
        metadata,
        protocolValue.name || '',
      ).map((colDef: SmartTableColDef) => {
        return (
          <EntityDataGridToolPanelListItem
            icon={colDef.headerComponentParams?.icon || 'database'}
            actionIcon="eye"
            text={colDef.headerName || ''}
            onClick={() => {
              gridSmartTableProtocolConditionService.addColumnDef(
                colDef,
              );
            }}
            disabled={colIds.includes(colDef.colId || '')}
          />
        );
      })}
    </div>
  );
};
